import React from 'react'

const Goals = () => {
  return (
    <div className="mace-goals">
      <h4>Goals</h4>
      <p>
        In the process of user research and design thinking, the followings goals are prioritised for the Mace application:
      </p>
      <ul>
        <li>
          <p>Present a proof of product to potential investors to boost expansion.</p>
        </li>
        <li>
          <p>Extend the capabilities of the Mace establishment.</p>
        </li>
        <li>
          <p>Effect the sales of product to consumers.</p>
        </li>
        <li>
          <p>Make Mace the suitable place to get high quality furnitures.</p>
        </li>
      </ul>
    </div>
  )
}

export default Goals